(ns ductile.ui.agent.artifacts.vega-lite
  (:require [clojure.string :as str]
            [nextjournal.clerk.render :as clerk-render]))

(defn- safe-table-value [v]
  (cond
    (map-entry? v) (pr-str v)
    (map? v) (pr-str v)
    (set? v) (pr-str v)
    (and (sequential? v) (not (string? v))) (pr-str v)
    :else v))

(defn- pair?
  [x]
  (and (sequential? x) (= 2 (count x))))

(defn- values-from-data
  [data]
  (cond
    (nil? data) []
    (and (sequential? data) (not (string? data)))
    (let [sample (take 20 data)]
      (cond
        (every? map? sample)
        (vec data)

        (every? pair? sample)
        (mapv (fn [[k v]] {:key (safe-table-value k) :value (safe-table-value v)}) data)

        :else
        (mapv (fn [idx v] {:index idx :value (safe-table-value v)}) (range) data)))
    (map? data)
    (mapv (fn [[k v]] {:key (safe-table-value k)
                       :value (safe-table-value v)})
          data)
    :else [{:value (safe-table-value data)}]))

(defn view
  [{:keys [spec payload]} {:keys [dataset-data error-view]}]
  (if-not (map? spec)
    [error-view {:error-message "Vega-Lite artifact requires artifact/spec map."}]
    (let [spec (if-let [dataset-id (:dataset-id payload)]
                 (assoc-in spec [:data :values] (values-from-data (dataset-data dataset-id)))
                 spec)]
      ;; Let Vega-Lite validate and catch any errors
      (try
        [clerk-render/render-vega-lite spec]
        (catch js/Error e
          [error-view {:error-message (str (.-message e)
                                           "\n\nSee https://vega.github.io/vega-lite/docs/ for valid Vega-Lite syntax.")
                       :error-type :vega-render-error
                       :invalid-spec spec}])))))
